import styled from 'styled-components'

const InfoStringIn = styled.span`
  color: ${props => props.theme.textInfo};
`

export default InfoStringIn
